export default __webpack_public_path__ + "static/media/trash-biohazard-open.b84b7cd7.svg";